import { render, staticRenderFns } from "./dealAttachment.vue?vue&type=template&id=3e0cd8ce&scoped=true&"
import script from "./dealAttachment.vue?vue&type=script&lang=js&"
export * from "./dealAttachment.vue?vue&type=script&lang=js&"
import style0 from "./dealAttachment.vue?vue&type=style&index=0&id=3e0cd8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0cd8ce",
  null
  
)

export default component.exports